import request from "../../utils/request";

export function getAllDrivers(params) {
  return request("/drivers", {
    method: "GET",
    params,
  });
}

export function doCreateDriver(params) {
  return request("/drivers", {
    method: "POST",
    data: params,
  });
}

export function doUpdateDriver(params) {
  return request(`/drivers/${params.id}`, {
    method: "PUT",
    data: params,
  });
}

export function doDeleteDriver(id) {
  return request(`/drivers/${id}`, {
    method: "DELETE",
  });
}
